import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { initialSliceEndpoints, initialSliceHosts, sliceCasesEndpoints, sliceCasesHosts } from './actions'

interface PromoOptimizerSettingsState {
  hosts: typeof initialSliceHosts.hosts
  endpoints: typeof initialSliceEndpoints.endpoints
}

const initialState: PromoOptimizerSettingsState = {
  ...initialSliceHosts,
  ...initialSliceEndpoints,
}

export const promoOptimizerSettingsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder).addSlice(sliceCasesHosts).addSlice(sliceCasesEndpoints)
})
